import React, { useEffect, useState } from 'react'
import { useGetEnterpriseDeptQuery, useUser_updateQuery } from '../../store/ReactWebSiteApi';
import { Flex, Space, Table } from 'antd';
import DeptAdd from './DeptAdd';
import DeptEdit from './DeptEdit';
import DeptDel from './DeptDel';
import Main from '../../cpn/Main';
import {DeleteOutlined,LogoutOutlined} from '@ant-design/icons';
function DeptList() {
     const [query,setQuery] = useState({
            e_id:localStorage.getItem('e_id'),
            ed_state:'2'
        })
    const [list,setList] = useState([]);
        const {data, isSuccess} = useGetEnterpriseDeptQuery(query);
        useEffect(() => {
            if(isSuccess){
                if(data.Status==='success'){
                    const newArr = data.Result.map((item) => {
                        const {ed_id:key,ed_name,ed_state,dept_num,user_num}=item;
                        return item = {key,ed_name,ed_state,dept_num,user_num}
                    })  
                    setList(newArr)                    
                }else{
                    setList(['暂无部门'])
                }
            }
        },[data, isSuccess])
        const columns = [    
            {
                key: 'type',
                title: '部门名称',
                dataIndex: 'ed_name',
            },            
            {
                key: 'dept_num',
                title: '子部门数量',
                dataIndex: 'dept_num',
            },            
            {
                key: 'user_num',
                title: '用户数量',
                dataIndex: 'user_num',
            },            
            {
                key: 'type',
                title: '部门名称',
                dataIndex: 'ed_name',
            },            
            {
                key: 'key',
                title: '部门编号',
                dataIndex: 'key',
            },            
            {
                key: 'action',
                width:'20%',
                title: '操作',
                render: (_, record) => {                
                    return <>
                        <Space>                        
                            <DeptEdit 
                                ed_id={record.key}
                                ed_state={record.ed_state}
                            />
                            <DeptDel 
                                ed_id={record.key}
                                ed_state={record.ed_state}
                                ed_name={record.ed_name}
                            />
                        </Space>
                    </>
                }
            },
        ]
    //获取操作员数据
    
    const [info, setInfo] = useState({
        eu_e_id:localStorage.getItem('e_id'),  
        eu_id: '',  
        eu_name: '',
        eu_ba_phone:'',
        eu_uid: localStorage.getItem('eu_id'),
        eu_uname: localStorage.getItem('eu_name'),
        parent_dept_id: '',
        eu_station_id:'',
    });   
    const {data:dataUser,isSuccess:isSuccessUser} = useUser_updateQuery({eu_id:localStorage.getItem('eu_id')})
    useEffect(() => {
        if(isSuccessUser){
            if(dataUser.Status==='success'){               
                setInfo(prevState => ({
                    ...prevState,
                    eu_name: dataUser.Result.eu_name,
                    eu_ba_phone: dataUser.Result.eu_ba_phone,
                    eu_role: dataUser.Result.eu_role,
                    eu_dept_id: dataUser.Result.eu_dept_id,
                    eu_show_authority: dataUser.Result.eu_show_authority,
                    parent_dept_id: dataUser.Result.ed_id,
                    eu_station_id: dataUser.Result.eu_station_id,
                    eu_station_name: dataUser.Result.eu_station_name,
                }))
                    
            }
        }
    },[dataUser,isSuccessUser])
    return (
        <Main t1='部门'>
            {query.ed_state==='2' ? <Flex justify='space-between' align='center'>
                <DeptAdd userInfo={info}/>
                <a 
                    style={{
                        marginRight:"20px",
                        fontSize:"18px"
                    }}
                    onClick={() => {
                        setQuery(prevState=>({...prevState,ed_state:'1'}))
                    }}
                ><DeleteOutlined /> 已删除部门</a>
            </Flex>:<Flex>
                        <a 
                            style={{
                                fontSize:"18px"
                                }}
                            onClick={() => {
                                setQuery(prevState=>({...prevState,ed_state:'2'}))
                            }}
                        ><LogoutOutlined /> 未删除部门</a>
                    </Flex>}
            <Table
                columns={columns}
                dataSource={list}
                pagination={{
                    defaultPageSize:20,
                }}
                style={{
                    marginTop:"10px"
                }}
            />
        </Main>
    )
}

export default DeptList